import React from 'react';
import LazyImage from '../LazyImage';
import './WeOffer.css';
import taxIcon from '../../assets/icons/tax/tax.webp';
import reviewIcon from '../../assets/icons/tax/review.webp';
import pcIcon from '../../assets/icons/tax/pc.webp';
import atoIcon from '../../assets/icons/tax/ato.webp';
import advisoryIcon from '../../assets/icons/tax/advisory.webp';
import deductionIcon from '../../assets/icons/tax/deduction.webp';
import interestIcon from '../../assets/icons/tax/interest.webp';
import futureIcon from '../../assets/icons/tax/future.webp';
import micIcon from '../../assets/icons/tax/mic.webp';

const WeOffer = () => {
    const offerData = [
        {
            id: 1,
            icon: taxIcon,
            title: "Tax Return Preparation",
            description: "Accurate and timely tax return preparation to ensure full compliance and maximum refund based on your individual or business profile."
        },
        {
            id: 2,
            icon: reviewIcon,
            title: "Tax Return Review",
            description: "We double-check your existing tax return for errors, missed deductions, or compliance gaps — helping you stay protected and possibly save."
        },
        {
            id: 3,
            icon: pcIcon,
            title: "Online Tax Lodgement",
            description: "Secure and fast online lodgement through ATO-approved channels. No paperwork, no waiting — just hassle-free submissions."
        },
        {
            id: 4,
            icon: atoIcon,
            title: "Detailed ATO Portal Checks",
            description: "We run a complete audit of your ATO portal, including payment history, notices, and lodgements — to ensure everything is accurate."
        },
        {
            id: 5,
            icon: advisoryIcon,
            title: "Advisory Services",
            description: "Expert guidance for smart financial decisions. We help you structure your finances, investments, and business for tax efficiency."
        },
        {
            id: 6,
            icon: deductionIcon,
            title: "Eligible Tax Deductions",
            description: "We identify every deduction you're entitled to — from work-related expenses to home office claims — so you never leave money on the table."
        },
        {
            id: 7,
            icon: interestIcon,
            title: "Interest & Dividend Income",
            description: "We handle and report your investment income accurately, ensuring tax obligations are met and managed wisely."
        },
        {
            id: 8,
            icon: futureIcon,
            title: "Future Tax Returns Planning",
            description: "Plan ahead with confidence. We assess your financial goals and develop a tax strategy that reduces liabilities and improves future returns."
        },
        {
            id: 9,
            icon: micIcon,
            title: "General Tax Return Support",
            description: "From document handling to ATO correspondence, we're here to support you through every step of the tax process."
        }
    ];

    return (
        <section className="we-offer">
            <div className="we-offer-container">
                <div className="we-offer-content">
                    <div className="we-offer-header">
                        <div className="we-offer-tag">What We Offer</div>
                        <h2 className="we-offer-title">
                            What's Included in Our<br />
                            <span className="text-primary">Individual Tax Return Services</span>
                        </h2>
                        <p className="we-offer-description">
                            We go beyond basic tax filing. Our expert team ensures your return is accurate,
                            compliant, and optimized for the best possible outcome — with complete support
                            from start to finish.
                        </p>
                    </div>

                    <div className="we-offer-cards">
                        {offerData.map((offer) => (
                            <div key={offer.id} className="offer-card">
                                <div className="offer-icon">
                                    <LazyImage src={offer.icon} alt={offer.title} />
                                </div>
                                <div className="offer-content">
                                    <h3 className="offer-title">{offer.title}</h3>
                                    <p className="offer-description">{offer.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default WeOffer;